export class NetworkEdge {
    constructor(e) {
        this.inTree = false;
        this.cut = NetworkEdge.infinity;
        this.iedge = e;
    }
    get source() {
        return this.iedge.source;
    }
    get target() {
        return this.iedge.target;
    }
    get separation() {
        return this.iedge.separation;
    }
    get crossingWeight() {
        return this.iedge.CrossingWeight;
    }
    get weight() {
        return this.iedge.weight;
    }
}
NetworkEdge.infinity = Number.MAX_SAFE_INTEGER;
//# sourceMappingURL=networkEdge.js.map